<template>
  <button
    v-tooltip="{ content: tooltip }"
    class="active:outlin-accent-1 box-border flex cursor-pointer items-center justify-center whitespace-nowrap rounded-md px-3 font-inter text-xs font-medium leading-8 transition duration-300 focus:outline focus:outline-2 focus:outline-accent-1 active:outline active:outline-2 disabled:!cursor-not-allowed disabled:!border-transparent disabled:!outline-none"
    v-bind="$attrs"
    :class="{
      'bg-gray-500 text-gray-100 hover:bg-gray-400 hover:text-gray-50 focus:bg-gray-600 active:bg-gray-600 disabled:!bg-gray-600 disabled:!text-gray-200 group-hover:bg-gray-400 group-hover:text-gray-50':
        !inverse,
      'bg-[color-mix(in_srgb,var(--c-g100)_80%,var(--c-g10))] text-gray-400 hover:bg-[color-mix(in_srgb,var(--c-g200)_50%,var(--c-g10))] hover:text-gray-500 focus:bg-[color-mix(in_srgb,var(--c-g100)_35%,var(--c-g10))] active:bg-[color-mix(in_srgb,var(--c-g100)_35%,var(--c-g10))] focus:text-gray-800 disabled:!bg-gray-100 disabled:!text-gray-300':
        inverse,
      'min-h-[24px] !px-0.5': $slots.icon && !$slots.default,
      '!px-2 !leading-6': xs,
      '!pl-1.5': !xs && $slots.icon && $slots.default,
      '!pl-1': xs && $slots.icon && $slots.default,
      '!pr-1.5': !xs && $slots.iconRight,
      '!pr-1': xs && $slots.iconRight,
      '!bg-confirm-1 !text-white hover:!bg-confirm-2 focus:!outline-confirm-2 active:!outline-confirm-2':
        success,
      '!bg-accent-1 !text-gray-50 hover:!bg-accent-1 hover:!text-gray-10 focus:!outline-accent-1 active:!outline-accent-1':
        accent,
      '!bg-structure-1 !text-gray-800 hover:!bg-structure-2 focus:!outline-structure-2 active:!outline-structure-2':
        purple,
      'focus:!outlone-destructive-2 !bg-destructive-1 !text-white hover:!bg-destructive-2 active:!outline-destructive-2':
        danger,
      '!bg-content-1 !text-white hover:!bg-content-2 focus:!outline-content-2 active:!outline-content-2':
        content,
      '!bg-structure-1 !text-white hover:!bg-structure-2 focus:!outline-structure-2 active:!outline-structure-2':
        structure,
      '!justify-start': alignLeft,
    }"
    :disabled="disabled || loading"
    style="position: relative"
  >
    <span
      :class="{ 'opacity-100': !loading, 'opacity-0': loading }"
      class="flex items-center justify-center gap-1"
    >
      <div
        v-if="$slots.icon"
        :class="{ '': !$slots.default }"
        class="grid h-[20px] min-w-[20px] items-center justify-center"
      >
        <slot name="icon" />
      </div>

      <span
        v-if="whiteSpaceWrap && $slots.default"
        class="whitespace-normal py-2 leading-4"
      >
        <slot />
      </span>
      <slot v-else />

      <div
        v-if="$slots.iconRight"
        class="grid h-[20px] min-w-[20px] items-center justify-center"
      >
        <slot name="iconRight" />
      </div>
    </span>
    <t-loading-spinner
      v-show="loading"
      class="left-[calc(50%-9px)]"
      style="position: absolute"
    ></t-loading-spinner>
  </button>
</template>

<script lang="ts">
// @TODO: After vue 3.3 upgrade refactor this: https://vuejs.org/guide/components/attrs.html#disabling-attribute-inheritance
// InheritAttrs is not supported in script setup
// So we define script and script with setup
export default {
  inheritAttrs: false,
};
</script>

<script lang="ts" setup>
import TLoadingSpinner from "../TLoadingSpinner/TLoadingSpinner.vue";

defineProps<{
  disabled?: boolean;
  arrowLeft?: boolean;
  icon?: boolean;
  secondary?: boolean;
  xs?: boolean;
  success?: boolean;
  danger?: boolean;
  purple?: boolean;
  loading?: boolean;
  alignLeft?: boolean;
  accent?: boolean;
  content?: boolean;
  structure?: boolean;
  inverse?: boolean;
  tooltip?: string;
  /**
   * Email-editor compatibility: twig-ui does not force-recolor SVGs, so this
   * is accepted as a no-op to keep the consumer API in sync with @topol/ui.
   */
  noColorSvg?: boolean;
  /**
   * Allow the button label to wrap onto multiple lines instead of nowrap.
   */
  whiteSpaceWrap?: boolean;
}>();
</script>
